import React, { createContext } from 'react';

const ColorModeContext = createContext({
  toggleColorMode: () => {},
  setPrimaryColorLight: () => {},
  setPrimaryColorDark: () => {},
  setAppLogoLight: () => {},
  setAppLogoDark: () => {},
  setAppLogoFavicon: () => {},
});

export default ColorModeContext;
